@if (preference?.HasAccessibleDashboard) {
  <section class="mt-6 mb-4">
    <h3 class="text-lg text-green-700 mb-2 font-bold">Landing page</h3>
    <p class="text-sm text-grey-700 mb-3">Choose the page shown after sign-in. This does not change the menu order.</p>
    <div class="flex flex-wrap items-center gap-3">
      <select class="text-box" [(ngModel)]="selectedLandingPageId" [disabled]="saving || disabled" aria-label="Landing page after sign-in">
        <option [ngValue]="null">Use customer default ({{ customerDefaultName }})</option>
        @if (savedOptionUnavailable) {
          <option [ngValue]="savedLandingPageId">Unavailable option (ID {{ savedLandingPageId }})</option>
        }
        @for (option of preference?.LandingPages; track option.LandingPageID) {
          <option [ngValue]="option.LandingPageID">{{ option.DisplayName }}</option>
        }
      </select>
      <button type="button" class="btn-primary" (click)="save()"
        [disabled]="saving || disabled || selectedLandingPageId === savedLandingPageId">
        {{ saving ? 'Saving...' : 'Save landing page' }}
      </button>
    </div>
    @if (savedOptionUnavailable) {
      <p class="text-sm text-grey-700 mt-2">The saved option is no longer available. The customer default is used until you choose another option.</p>
    }
  </section>
} @else if (loadFailed) {
  <p class="text-sm text-danger-base mt-4">Landing page settings could not be loaded.</p>
}
